import React from 'react'
import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    paddingTop: 5
  }
})

export type TabPanelProps = {
  currentTab: number,
  index: number
}

export const TabPanel: React.FC<TabPanelProps> = ({ children, currentTab, index }) => {
  const classes = useStyles()

  if (currentTab !== index) {
    return null
  }

  return (
    <Box className={classes.container}>
      {children}
    </Box>
  )
}
